import { useMutation, useQuery } from '@tanstack/react-query'

import useResize from '../../../hooks/useResize'
import { TAGS } from '../../../services/Tags'
import { getCategories } from '../../../services/talents'
import { useEffect, useState } from 'react'
import {
  LIMIT_OF_CHARACTERS,
  VIEWPORT_LG,
  IS_HIRING_ADVISOR,
} from '../../../utils/constants'
import { ErrorMessage } from '@hookform/error-message'
import { ENGLISH_LEVEL } from '../../../utils/constants/filters'
import Button from '../../../components/Button'
import RegisterFastIconFour from '../../../icons/RegisterFastIconFour'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import {
  createOfferHutritNext,
  getMyOffersManagement,
} from '../../../services/OfferManagement'
import { createOfferHutritNextByHa } from '../../../services/HiringAdvisor/createOfferHutritNextByHa'
import { listOfCompaniesByHiringAdvisor } from '../../../services/HiringAdvisor'
import { getPromptTemplates } from '../../../services/customPrompts'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { useNavigate, useParams } from 'react-router-dom'
import CreateJobOfferSuccess from '../../../components/Modals/CreateJobOfferSuccess'
import Loader from '../../../components/Loader'
import confetti from 'canvas-confetti'

import HelperIconTwo from '../../../icons/HelperIconTwo'
import { useTranslation } from 'react-i18next'
import { Countdown } from './Countdown'
import { getlanguages } from '../../../services/Admin'
import { findRepeatedElements } from '../../../utils'
import DisableTrashIcon from '../../../icons/DisableTrashIcon'
import TrashIcon from '../../../icons/TrashIcon'
//import dayjs from 'dayjs'
import SelectSkills from '../../../components/SelectSkills'
import InnerBanner from '../../../components/InnerBanner'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import Toast from '../../../components/Toast/Toast'
import Tiptap from '../../../components/Tiptap/Tiptap'

const languagesValues = {
  idLang: '',
  lang_level_id: '',
}

const initialValues = {
  name: '',
  langOffer: [languagesValues],
  skillsOffer: [],
  modalitys: 0,
  description: '',
  activities: '',
  additionalContactInformation: '',
  IdCategorie: 1,
  promptId: '',
  valueLot: '',
}

const CreateJobOfferByJuniors = () => {
  // Estado para la compañía seleccionada
  const [selectedCompanyId, setSelectedCompanyId] = useState('')

  // Obtener lista de compañías solo si es Hiring Advisor
  const { data: companiesList = [], isLoading: isLoadingCompanies } = useQuery(
    ['list-companies-ha'],
    listOfCompaniesByHiringAdvisor,
    {
      enabled: IS_HIRING_ADVISOR,
    }
  )

  const { data: promptTemplatesData } = useQuery(
    ['prompt-templates-ha'],
    () => getPromptTemplates({ page: 0 }),
    { enabled: IS_HIRING_ADVISOR }
  )
  const promptTemplates = Array.isArray(promptTemplatesData)
    ? promptTemplatesData
    : promptTemplatesData?.count ?? promptTemplatesData?.data ?? promptTemplatesData?.templates ?? []
  const { t } = useTranslation()
  const MySwal = withReactContent(Swal)
  const { id } = useParams()
  const navigate = useNavigate()
  const [showWaitCount, setShowWaitCount] = useState(false)
  const [endMessage, setEndMessage] = useState(false)
  const [matchCount, setMatchCount] = useState(0)
  const [offerId, setOfferId] = useState(0)

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
    reset,
  } = useForm({ defaultValues: initialValues })

  const {
    fields: languagesFields = [],
    append: appendLanguages = () => {},
    remove: removeLanguages = () => {},
  } = useFieldArray({
    control,
    name: 'langOffer',
  })

  const activities = watch('activities')
  const description = watch('description')
  const modalitys = watch('modalitys')
  const langOffer = watch('langOffer')

  const [repeatedLanguages, setRepeatedLanguages] = useState([])
  const [newLanguages] = useState([])
  const listOfLanguages = langOffer
  const lastItemInTheLanguagesArray = langOffer?.[langOffer?.length - 1]
  const transformLanguagesFields = langOffer?.map(({ idLang }) => idLang)

  const { data: listLanguagesData } = useQuery(
    [TAGS.list_of_idioms],
    getlanguages
  )

  const data = watch()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { data: categoriesData = [] } = useQuery(
    [TAGS.categories],
    getCategories
  )

  const { data: companyOffersData = [] } = useQuery([TAGS.offers_company], () =>
    getMyOffersManagement({ page: 0, isHutritNext: true })
  )

  const { offers } = companyOffersData

  // Mutación para crear oferta por Hiring Advisor
  const {
    mutate: createOfferHutritNextByHaMutate,
    isLoading: isLoadingCreateOfferHutritNextByHa,
  } = useMutation([TAGS.create_offer_hutrit_next], createOfferHutritNextByHa)

  // Mutación original para otros perfiles
  const {
    mutate: createOfferHutritNextMutate,
    isLoading: isLoadingCreateOfferHutritNext,
  } = useMutation([TAGS.create_offer_hutrit_next], createOfferHutritNext, {
    onSuccess: ({ response, res }) => {
      if (response?.status === 200) {
        confetti()
        if (offers?.length > 0) {
          CreateJobOfferSuccess({
            matchCount: res?.countMatch,
            id: res?.idOffer,
            navigate,
            isJuniorView: true,
          })
        } else {
          setMatchCount(res?.countMatch)
          setOfferId(res?.idOffer)
          setEndMessage(true)
        }
      }
      if (response?.status !== 200) {
        MySwal.fire({
          title: <strong>{t('error_in_the_system')}</strong>,
          icon: 'error',
          confirmButtonColor: 'Red',
        })
        return
      }
    },
  })

  const [selectedSkills, setSelectedSkills] = useState([])

  const parseSelectedSkills = selectedSkills?.map((skill) => ({
    idSkill: skill?.value,
    required: skill?.required ?? false,
  }))

  const customData = {
    ...data,
    IdCategorie: Number(data?.IdCategorie),
    skillsOffer: parseSelectedSkills,
    langOffer: listOfLanguages.filter((props) => props?.idLang !== ''),
    modalitys: [Number(modalitys)],
    additionalContactInformation: null,
    ...(IS_HIRING_ADVISOR && selectedCompanyId
      ? { companyId: selectedCompanyId }
      : {}),
    ...(IS_HIRING_ADVISOR && data?.promptId
      ? { promptId: Number(data.promptId) }
      : {}),
    ...(IS_HIRING_ADVISOR && data?.valueLot
      ? { valueLot: data.valueLot }
      : {}),
  }

  const onSubmit = () => {
    if (selectedSkills?.length > 12) {
      return
    }

    if (offers?.length > 0 || IS_HIRING_ADVISOR) {
      if (IS_HIRING_ADVISOR) {
        const aiWindow = window.open('', '_blank')
        createOfferHutritNextByHaMutate(customData, {
          onSuccess: ({ response, res }, variables) => {
            if (response?.status === 200) {
              confetti()
              Toast({ title: 'Oferta creada con éxito' })
              reset(initialValues)
              const offerId = res?.offer
              const offerName = encodeURIComponent(variables?.name || '')
              const aiParams = offerId
                ? `offerId=${offerId}&offerName=${offerName}`
                : `offerName=${offerName}`
              if (aiWindow) aiWindow.location.href = `/hiring-advisor-ai?${aiParams}`
              navigate('/list-of-offers-juniors')
            }
            if (response?.status !== 200) {
              if (aiWindow) aiWindow.close()
              MySwal.fire({
                title: <strong>{t('error_in_the_system')}</strong>,
                icon: 'error',
                confirmButtonColor: 'Red',
              })
            }
          },
        })
      } else {
        createOfferHutritNextMutate(customData)
      }
    } else {
      setShowWaitCount(true)
    }
  }

  const handleModalityChange = (event) => {
    const checkboxValue = event.target.value
    setValue('modalitys', checkboxValue)
  }

  useEffect(() => {
    if (
      lastItemInTheLanguagesArray?.idLang !== '' &&
      lastItemInTheLanguagesArray?.lang_level_id !== ''
    ) {
      appendLanguages(languagesValues)
    }
  }, [
    lastItemInTheLanguagesArray?.idLang,
    lastItemInTheLanguagesArray?.lang_level_id,
  ])

  useEffect(() => {
    setRepeatedLanguages(findRepeatedElements(transformLanguagesFields))
  }, [newLanguages])

  return (
    <>
      {showWaitCount && (
        <Countdown
          createOfferManagementMutate={createOfferHutritNextMutate}
          customData={customData}
          endMessage={endMessage}
          id={id}
          matchCount={matchCount}
          offerId={offerId}
          parseSelectedSkills={parseSelectedSkills}
          modalitys={modalitys}
          isJuniorView
        />
      )}

      {!showWaitCount && (
        <DashboardWrapper>
          <div
            className={`${
              viewportSize[0] <= VIEWPORT_LG ? '' : 'stepper-container'
            } d-flex flex-lg-row flex-column-reverse justify-content-center align-items-center align-items-lg-start p-lg-0 p-3`}
          >
            <div className="w-100">
              <InnerBanner
                className="mb-3"
                before="Ofertas"
                beforeRoute={PRIVATE_ROUTES.list_of_offers_juniors}
                text="Nueva Oferta"
              />
              <h2
                className="text-bg-brand d-none d-lg-inline-block"
                style={{
                  fontWeight: 800,
                  marginTop: isMobile ? '' : '90px',
                }}
              >
                {t('what_profiles_are_you_looking_for')}
              </h2>
              <form
                className="border rounded p-4 bg-white"
                style={{
                  marginTop: isMobile ? '' : '40px',
                  width: isMobile ? '100%' : '85%',
                }}
                onSubmit={handleSubmit(onSubmit)}
              >
                {/* Select de compañía solo para Hiring Advisor */}
                {IS_HIRING_ADVISOR && (
                  <div style={{ marginBottom: '24px' }}>
                    <label className="form-label text-on-bg-primary">
                      Selecciona la compañía
                    </label>
                    <select
                      className="form-control"
                      value={selectedCompanyId}
                      onChange={(e) => setSelectedCompanyId(e.target.value)}
                      required
                      disabled={isLoadingCompanies}
                    >
                      <option value="" disabled>
                        {isLoadingCompanies
                          ? 'Cargando compañías...'
                          : 'Selecciona una compañía'}
                      </option>
                      {companiesList?.list?.map((company) => (
                        <option key={company.id} value={company.id}>
                          {`${company?.name ? company?.name + '-' : ''} ${company?.email}`}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* Prompt y salario solo para Hiring Advisor */}
                {IS_HIRING_ADVISOR && (
                  <div className="d-flex gap-3" style={{ marginBottom: '24px' }}>
                    <div style={{ flex: 1 }}>
                      <label className="form-label text-on-bg-primary">
                        Prompt
                      </label>
                      <select
                        className="form-control"
                        {...register('promptId')}
                      >
                        <option value="">Selecciona un prompt</option>
                        {promptTemplates.filter((p) => p.type_prompt_template_id !== 4).map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div style={{ flex: 1 }}>
                      <label className="form-label text-on-bg-primary">
                        Salario / Lote de valor
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Ej: $3,000 - $4,000 USD"
                        {...register('valueLot')}
                      />
                    </div>
                  </div>
                )}

                <div>
                  <label className="d-flex align-items-center gap-2 form-label text-on-bg-primary">
                    <span>{t('offer_name')}</span>
                    <div
                      title={t(
                        'assign_a_name_so_you_can_identify_your_offers_faster_this_information_will_not_be_visible_to_the_talent'
                      )}
                    >
                      <HelperIconTwo />
                    </div>
                  </label>

                  <input
                    className="form-control"
                    type="text"
                    placeholder={t('assign_a_name_to_the_offer')}
                    {...register('name', {
                      required: t('this_field_is_required'),
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="name"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>
                <div
                  className="sector-company"
                  style={{ marginTop: isMobile ? '17px' : '32px' }}
                >
                  <label className="form-label text-on-bg-primary">
                    {t('position_offered')}
                  </label>
                  <select
                    id="category-select"
                    className="form-control"
                    {...register('IdCategorie', {
                      required: t('this_field_is_required'),
                    })}
                  >
                    <option disabled value="">
                      {t('choose_the_position')}
                    </option>
                    {categoriesData?.map(({ id, name }) => (
                      <option key={id} value={id}>
                        {name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage
                    errors={errors}
                    name="IdCategorie"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>

                <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
                  <label className="text-on-bg-primary">{t('languages')}</label>
                  <div className="d-flex flex-column-reverse mt-2">
                    {languagesFields.map((item, index) => {
                      return (
                        <li
                          key={item.id}
                          className={`${
                            item?.idLang !== 'gap-1' && 'gap-3'
                          } d-flex flex-row  mb-1 `}
                        >
                          <div className="w-100">
                            <select
                              className="form-control"
                              {...register(`langOffer.${index}.idLang`, {
                                required: {
                                  value:
                                    langOffer?.length <= 1 ||
                                    lastItemInTheLanguagesArray?.lang_level_id !==
                                      '',
                                  message: t('required'),
                                },
                              })}
                            >
                              <option disabled value="">
                                {t('select_a_languages')}
                              </option>
                              {listLanguagesData?.map(({ id, name }) => (
                                <option value={id} key={id}>
                                  {name}
                                </option>
                              ))}
                            </select>
                            <div className="w-25">
                              <ErrorMessage
                                errors={errors}
                                name={`langOffer.${index}.idLang`}
                                render={({ message }) => (
                                  <span className="text-danger font-small">
                                    {message}
                                  </span>
                                )}
                              />
                            </div>
                          </div>
                          <div className="w-100">
                            <select
                              className="form-control sector-company"
                              {...register(`langOffer.${index}.lang_level_id`, {
                                required: {
                                  value:
                                    langOffer?.length <= 1 ||
                                    lastItemInTheLanguagesArray?.idLang !== '',
                                  message: t('required'),
                                },
                              })}
                            >
                              <option disabled value="">
                                Selecciona un nivel
                              </option>
                              {ENGLISH_LEVEL?.map(({ id, name }) => (
                                <option key={id} value={id}>
                                  {name}
                                </option>
                              ))}
                            </select>

                            <div className="w-25">
                              <ErrorMessage
                                errors={errors}
                                name={`langOffer.${index}.lang_level_id`}
                                render={({ message }) => (
                                  <span className="text-danger font-small">
                                    {message}
                                  </span>
                                )}
                              />
                            </div>
                          </div>
                          <div
                            title={t('remove_language')}
                            className="text-secondary cursor-pointer"
                            onClick={() => {
                              if (index === langOffer?.length - 1) return
                              removeLanguages(index)
                            }}
                          >
                            {index === langOffer?.length - 1 ? (
                              <DisableTrashIcon />
                            ) : (
                              <TrashIcon />
                            )}{' '}
                          </div>
                        </li>
                      )
                    })}
                  </div>
                  <div className="d-flex flex-column">
                    {repeatedLanguages.length > 0 && (
                      <span className="text-danger font-small">
                        {t('you_have_repeated_languages')}
                      </span>
                    )}
                    {langOffer?.length < 1 && (
                      <span className="text-danger font-small">
                        {t('minimum_languages', { value: 1 })}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  id="search-for-skills"
                  style={{ marginTop: isMobile ? '17px' : '32px' }}
                >
                  <label className="text-on-bg-primary form-label">
                    {t('required_skills')}
                  </label>
                  <SelectSkills
                    setSelectedSkills={setSelectedSkills}
                  />
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ marginTop: '32px' }}
                >
                  <label className="form-label text-on-bg-primary">
                    Modalidad
                  </label>
                  <div className="d-flex gap-3">
                    <div className="d-flex align-items-center gap-2">
                      <input
                        checked={true}
                        {...register('modalitys', {
                          required: 'Requerido',
                        })}
                        type="checkbox"
                        className="mycheck"
                        value={2}
                        onChange={handleModalityChange}
                      />
                      <span>{t('remote')}</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        {...register('modalitys', {
                          required: 'Requerido',
                        })}
                        checked={Number(modalitys) === 1}
                        type="checkbox"
                        className="mycheck"
                        value={1}
                        onChange={handleModalityChange}
                        disabled
                      />
                      <span
                        style={{
                          color: '#89B5A4',
                        }}
                      >
                        Presencial
                      </span>
                    </div>
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="modalitys"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                  <span
                    style={{
                      fontSize: '12px',
                    }}
                    className="mt-2 mb-2 text-on-bg-secondary"
                  >
                    Los perfiles en prácticas siempre son 100% remoto.
                  </span>
                </div>
                <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
                  <label className="form-label text-on-bg-primary">
                    Perfil deseado y beneficios adicionales
                  </label>
                  <Controller
                    control={control}
                    name="activities"
                    render={({ field: { onChange, value } }) => (
                      <Tiptap
                        onChange={onChange}
                        initialValue={value}
                        currentText={activities}
                        limitOfCharacters={LIMIT_OF_CHARACTERS}
                        setComandsTiptap={() => {}}
                      />
                    )}
                    rules={{
                      required: t('this_field_is_required'),
                      validate: (value) => {
                        if (value) {
                          const urlRegex = /(http(s)?:\/\/[^\s]+)/gi
                          if (urlRegex.test(value)) {
                            return t('no_external_links_allowed_in_this_field')
                          }
                        }
                        return true
                      },
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="activities"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>
                <div style={{ marginTop: isMobile ? '17px' : '32px' }}>
                  <label className="form-label text-on-bg-primary">
                    Descripción del cargo y funciones a realizar
                  </label>
                  <Controller
                    control={control}
                    name="description"
                    render={({ field: { onChange, value } }) => (
                      <Tiptap
                        onChange={onChange}
                        initialValue={value}
                        currentText={description}
                        limitOfCharacters={LIMIT_OF_CHARACTERS}
                        setComandsTiptap={() => {}}
                      />
                    )}
                    rules={{
                      required: t('this_field_is_required'),
                      validate: (value) => {
                        if (value) {
                          const urlRegex = /(http(s)?:\/\/[^\s]+)/gi
                          if (urlRegex.test(value)) {
                            return t('no_external_links_allowed_in_this_field')
                          }
                        }
                        return true
                      },
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="description"
                    render={({ message }) => (
                      <span className="text-danger font-small">{message}</span>
                    )}
                  />
                </div>
                <div className="d-flex justify-content-center justify-content-lg-start mt-4 mb-4">
                  <Button
                    className="btn-white border border-on-bg-primary text-on-bg-primary me-2"
                    type="button"
                  >
                    {t('save_as_draft')}
                  </Button>{' '}
                  <Button
                    disabled={
                      IS_HIRING_ADVISOR
                        ? isLoadingCreateOfferHutritNextByHa
                        : isLoadingCreateOfferHutritNext
                    }
                    className="btn-bg-CTA-primary"
                    type="submit"
                  >
                    {(
                      IS_HIRING_ADVISOR
                        ? isLoadingCreateOfferHutritNextByHa
                        : isLoadingCreateOfferHutritNext
                    ) ? (
                      <Loader />
                    ) : (
                      t('publish_offer')
                    )}
                  </Button>
                </div>
              </form>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center w-100">
              <RegisterFastIconFour />
              <span
                className={`${
                  viewportSize[0] <= VIEWPORT_LG ? 'w-100' : 'w-50'
                } text-on-bg-secondary text-center mt-4`}
              >
                {t(
                  'say_goodbye_to_manual_talent_search_complete_your_job_offer_and_get_ready_to_meet_your_ideal_candidate'
                )}
              </span>
            </div>
          </div>
        </DashboardWrapper>
      )}
    </>
  )
}

export default CreateJobOfferByJuniors
